import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

const FACULTES = [
  { group: "Médecine", options: ["Médecine Tunis", "Médecine Sousse", "Médecine Monastir", "Médecine Sfax"] },
  { group: "Dentaire", options: ["Dentaire Monastir"] },
  { group: "Pharmacie", options: [ "Pharmacie Monastir"] },
];

const HEURES_DEBUT = ["00:00","06:00","07:00","08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00"];
const HEURES_FIN   = ["01:00","02:00","03:00","04:00","05:00","08:00","10:00","12:00","14:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00","23:59"];

const FORMULES = [

  { value: "8h/jour",    label: "8h / jour" },
  { value: "12h/jour",   label: "12h / jour" },
  { value: "Non décidé", label: "Je ne sais pas encore" },
];

const INITIAL = {
  prenom: "", nom: "", tel: "",
  faculte: "", heureDebut: "", heureFin: "",
  formule: "", notes: "",
};

export default function ECNInscription() {
  const [form, setForm]       = useState(INITIAL);
  const [errors, setErrors]   = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [toast, setToast]     = useState("");

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 4000);
  };

  const validate = () => {
    const e = {};
    if (form.prenom.trim().length < 2)                  e.prenom     = "Champ requis";
    if (form.nom.trim().length < 2)                     e.nom        = "Champ requis";
    if (form.tel.replace(/\s/g, "").length < 8)         e.tel        = "Numéro invalide";
    if (!form.faculte)                                  e.faculte    = "Veuillez choisir une faculté";
    if (!form.heureDebut)                               e.heureDebut = "Requis";
    if (!form.heureFin)                                 e.heureFin   = "Requis";
    if (!form.formule)                                  e.formule    = "Veuillez choisir une formule";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      await addDoc(collection(db, "ECN"), {
        prenom:    form.prenom.trim(),
        nom:       form.nom.trim(),
        tel:       form.tel.trim(),
        faculte:   form.faculte,
        horaires:  { debut: form.heureDebut, fin: form.heureFin },
        formule:   form.formule,
        notes:     form.notes.trim() || null,
        createdAt: serverTimestamp(),
        statut:    "en_attente",
      });
      setSuccess(true);
    } catch (err) {
      console.error(err);
      showToast("Erreur lors de l'envoi. Réessaie ou contacte-nous directement.");
    } finally {
      setLoading(false);
    }
  };

  const fieldCls = (key) =>
    `ws-field${errors[key] ? " ws-field--invalid" : ""}`;

  if (success) {
    return (
      <div style={styles.wrap}>
        <div style={styles.successBox}>
          <div style={styles.successIcon}>✓</div>
          <h3 style={styles.successTitle}>Pré-inscription reçue !</h3>
          <p style={styles.successName}>
            {form.prenom} {form.nom}, ta demande pour la formule{" "}
            <strong>{form.formule}</strong> a bien été enregistrée.
          </p>
          <p style={styles.successSub}>
            On revient vers toi <strong>avant le 20 juin</strong> avec la
            confirmation et le lien de paiement.
          </p>
          <p style={styles.successContact}>
            Des questions ?{" "}
            <a href="tel:+21670550013" style={styles.link}>
              +216 70 550 013
            </a>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.wrap}>
      {/* Toast */}
      {toast && <div style={styles.toast}>{toast}</div>}

      {/* Badge */}
      <div style={styles.badge}>
        <span style={styles.badgeDot} />
        Pré-inscription ECN 2026
      </div>

      <h2 style={styles.title}>Rejoins WeStudy cet été</h2>
      <p style={styles.sub}>
        Formule spéciale révision ECN — Juillet &amp; Août 2026. Remplis ce
        formulaire avant le <strong>16 juin</strong>, on revient vers toi le{" "}
        <strong>20 juin</strong> avec la confirmation.
      </p>

      {/* Deadline banner */}
      <div style={styles.deadline}>
        <span style={{ fontSize: 18 }}>📅</span>
        <div style={styles.deadlineText}>
          <strong>Date limite :</strong> 16 juin 2026 &nbsp;·&nbsp;{" "}
          <strong>Retour :</strong> 20 juin 2026
          <br />
          Abonnement 2 mois (Juillet + Août), puis retour à la tarification normale.
        </div>
      </div>

      {/* Prénom / Nom */}
      <div style={styles.row2}>
        <div style={styles.field}>
          <label style={styles.label}>
            Prénom <span style={styles.req}>*</span>
          </label>
          <input
            style={errors.prenom ? { ...styles.input, ...styles.inputError } : styles.input}
            placeholder="Yasmine"
            value={form.prenom}
            onChange={e => set("prenom", e.target.value)}
            autoComplete="given-name"
          />
          {errors.prenom && <div style={styles.errorMsg}>{errors.prenom}</div>}
        </div>
        <div style={styles.field}>
          <label style={styles.label}>
            Nom <span style={styles.req}>*</span>
          </label>
          <input
            style={errors.nom ? { ...styles.input, ...styles.inputError } : styles.input}
            placeholder="Ben Salah"
            value={form.nom}
            onChange={e => set("nom", e.target.value)}
            autoComplete="family-name"
          />
          {errors.nom && <div style={styles.errorMsg}>{errors.nom}</div>}
        </div>
      </div>

      {/* Téléphone */}
      <div style={styles.field}>
        <label style={styles.label}>
          Numéro de téléphone <span style={styles.req}>*</span>
        </label>
        <input
          style={errors.tel ? { ...styles.input, ...styles.inputError } : styles.input}
          placeholder="+216 XX XXX XXX"
          value={form.tel}
          onChange={e => set("tel", e.target.value)}
          autoComplete="tel"
        />
        {errors.tel && <div style={styles.errorMsg}>{errors.tel}</div>}
      </div>

      {/* Faculté */}
      <div style={styles.field}>
        <label style={styles.label}>
          Faculté <span style={styles.req}>*</span>
        </label>
        <select
          style={errors.faculte ? { ...styles.select, ...styles.inputError } : styles.select}
          value={form.faculte}
          onChange={e => set("faculte", e.target.value)}
        >
          <option value="">— Sélectionner —</option>
          {FACULTES.map(g => (
            <optgroup key={g.group} label={g.group}>
              {g.options.map(o => (
                <option key={o} value={o}>{o}</option>
              ))}
            </optgroup>
          ))}
        </select>
        {errors.faculte && <div style={styles.errorMsg}>{errors.faculte}</div>}
      </div>

      {/* Horaires */}
      <div style={styles.field}>
        <label style={styles.label}>
          Horaires habituels <span style={styles.req}>*</span>
        </label>
        <div style={styles.timeRow}>
          <div style={{ flex: 1 }}>
            <select
              style={errors.heureDebut ? { ...styles.select, ...styles.inputError } : styles.select}
              value={form.heureDebut}
              onChange={e => set("heureDebut", e.target.value)}
            >
              <option value="">Arrivée</option>
              {HEURES_DEBUT.map(h => <option key={h} value={h}>{h}</option>)}
            </select>
            {errors.heureDebut && <div style={styles.errorMsg}>{errors.heureDebut}</div>}
          </div>
          <span style={styles.timeSep}>→</span>
          <div style={{ flex: 1 }}>
            <select
              style={errors.heureFin ? { ...styles.select, ...styles.inputError } : styles.select}
              value={form.heureFin}
              onChange={e => set("heureFin", e.target.value)}
            >
              <option value="">Départ</option>
              {HEURES_FIN.map(h => <option key={h} value={h}>{h}</option>)}
            </select>
            {errors.heureFin && <div style={styles.errorMsg}>{errors.heureFin}</div>}
          </div>
        </div>
        <div style={styles.hint}>
          Horaires approximatifs — juste pour qu'on comprenne ton rythme.
        </div>
      </div>

      {/* Pricing note */}
      <div style={styles.pricingBox}>
        <div style={styles.pricingTitle}>🏷 Tarifs spéciaux ECN — Été 2026</div>
        <div style={styles.pricingNote}>
          Tarifs définitifs communiqués le 20 juin — indique ta préférence ci-dessous.
        </div>
      </div>

      {/* Formule */}
      <div style={styles.field}>
        <label style={styles.label}>
          Formule souhaitée <span style={styles.req}>*</span>
        </label>
        <select
          style={errors.formule ? { ...styles.select, ...styles.inputError } : styles.select}
          value={form.formule}
          onChange={e => set("formule", e.target.value)}
        >
          <option value="">— Sélectionner —</option>
          {FORMULES.map(f => (
            <option key={f.value} value={f.value}>{f.label}</option>
          ))}
        </select>
        {errors.formule && <div style={styles.errorMsg}>{errors.formule}</div>}
      </div>

      {/* Notes */}
      <div style={styles.field}>
        <label style={styles.label}>
          Notes / Questions{" "}
          <span style={{ fontWeight: 400, color: "#888" }}>(optionnel)</span>
        </label>
        <textarea
          style={styles.textarea}
          placeholder="Des questions sur l'espace, les règles, les services..."
          maxLength={300}
          value={form.notes}
          onChange={e => set("notes", e.target.value)}
        />
        <div style={styles.counter}>{form.notes.length}/300</div>
      </div>

      {/* Submit */}
      <button
        style={loading ? { ...styles.submitBtn, ...styles.submitBtnDisabled } : styles.submitBtn}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Envoi en cours..." : "Envoyer ma pré-inscription →"}
      </button>
    </div>
  );
}

const styles = {
  wrap: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    maxWidth: 600,
    margin: "0 auto",
    padding: "2rem 1rem",
    color: "#111110",
  },
  badge: {
    display: "inline-flex", alignItems: "center", gap: 6,
    background: "#E1F5EE", color: "#0F6E56",
    border: "1px solid #9FE1CB",
    fontSize: 12, fontWeight: 500,
    padding: "4px 10px", borderRadius: 6,
    marginBottom: "1rem",
  },
  badgeDot: {
    width: 6, height: 6, borderRadius: "50%", background: "#1D9E75",
  },
  title: { fontSize: 22, fontWeight: 500, marginBottom: 6 },
  sub:   { fontSize: 14, color: "#6f6f69", lineHeight: 1.6, marginBottom: "1.5rem" },
  deadline: {
    background: "#f4f4f2", border: "1px solid #e5e5e0",
    borderRadius: 8, padding: "12px 14px",
    marginBottom: "1.5rem", display: "flex", gap: 12, alignItems: "flex-start",
  },
  deadlineText: { fontSize: 13, color: "#6f6f69", lineHeight: 1.6 },
  row2:  { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  field: { marginBottom: "1.25rem" },
  label: { display: "block", fontSize: 13, fontWeight: 500, color: "#6f6f69", marginBottom: 6 },
  req:   { color: "#E24B4A" },
  input: {
    width: "100%", padding: "8px 12px",
    border: "1px solid #d0d0c8", borderRadius: 8,
    fontSize: 14, outline: "none",
    fontFamily: "inherit", background: "#fff", color: "#111110",
  },
  select: {
    width: "100%", padding: "8px 12px",
    border: "1px solid #d0d0c8", borderRadius: 8,
    fontSize: 14, outline: "none",
    fontFamily: "inherit", background: "#fff", color: "#111110",
    appearance: "auto",
  },
  inputError: { borderColor: "#E24B4A" },
  errorMsg:   { fontSize: 12, color: "#E24B4A", marginTop: 4 },
  timeRow:    { display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 8, alignItems: "flex-start" },
  timeSep:    { fontSize: 13, color: "#6f6f69", paddingTop: 9 },
  hint:       { fontSize: 12, color: "#a8a89e", marginTop: 6 },
  pricingBox: {
    background: "#E1F5EE", border: "1px solid #9FE1CB",
    borderRadius: 10, padding: "1rem 1.25rem", marginBottom: "1.5rem",
  },
  pricingTitle: { fontSize: 14, fontWeight: 500, color: "#0F6E56", marginBottom: 6 },
  pricingNote:  { fontSize: 12, color: "#0F6E56" },
  textarea: {
    width: "100%", padding: "8px 12px",
    border: "1px solid #d0d0c8", borderRadius: 8,
    fontSize: 14, fontFamily: "inherit",
    minHeight: 72, resize: "vertical",
    outline: "none", color: "#111110", background: "#fff",
  },
  counter: { fontSize: 12, color: "#a8a89e", textAlign: "right", marginTop: 4 },
  submitBtn: {
    width: "100%", padding: 12,
    background: "#1D9E75", color: "#fff",
    border: "none", borderRadius: 8,
    fontSize: 15, fontWeight: 500,
    cursor: "pointer", fontFamily: "inherit",
  },
  submitBtnDisabled: { background: "#5DCAA5", cursor: "not-allowed" },
  toast: {
    position: "fixed", bottom: 20, left: "50%", transform: "translateX(-50%)",
    background: "#A32D2D", color: "#fff",
    padding: "10px 18px", borderRadius: 8, fontSize: 13, zIndex: 99,
  },
  successBox: { textAlign: "center", padding: "2rem 1rem" },
  successIcon: {
    fontSize: 40, color: "#1D9E75",
    marginBottom: "1rem", display: "block",
  },
  successTitle: { fontSize: 20, fontWeight: 500, marginBottom: 8 },
  successName:  { fontSize: 14, color: "#6f6f69", lineHeight: 1.6 },
  successSub:   { fontSize: 14, color: "#6f6f69", marginTop: 8, lineHeight: 1.6 },
  successContact: { fontSize: 13, color: "#a8a89e", marginTop: 16 },
  link: { color: "#1D9E75", textDecoration: "none" },
};
